// Contact.js
import React from 'react';

function Contact() {
  return (
    <div className="min-h-screen  flex items-center justify-center">
      <div className="bg-amber-400 p-8 m-4 rounded shadow-md w-96">
        <h1 className="text-2xl font-semibold mb-4">Contact Us</h1>
        <h1 className="text-1xl font-semibold mb-4">Call us</h1>
        <div className="mt-4">
          <p className="text-gray-600">Phone: <a href="tel:+248-240-3558">+1 248-240-3558 || +1 248-943-7753</a></p>
          
        </div>
        <h1 className="text-1xl  font-semibold m-4">Or fill out this form</h1>
        <form>
          <div className="mb-4">
            <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:border-blue-500"
              placeholder="Your name"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:border-blue-500"
              placeholder="Your email"
            />
          </div>
          <div className="mb-6">
            <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Message</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              className="w-full px-4 py-2 rounded border border-gray-300 focus:outline-none focus:border-blue-500"
              placeholder="Your message"
            ></textarea>
          </div>
          <div className="flex justify-end">
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
            >
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Contact;
